import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { WalletServiceService } from 'src/app/services/walletService';

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrl: './wallet.component.scss'
})
export class WalletComponent {
  wallet: any = {};
  history: any[] = [];
activePage: string = 'overview';

  Math = Math;
balance: number = 0;
totalBalance = 0;
totalCredit = 0;
totalDebit = 0;
rewardHistory: any[] = [];
cashbackHistory: any[] = [];
loading = true;
userId = localStorage.getItem('userId');
  constructor(private http: HttpClient,
    private wallwtservice: WalletServiceService
  ) {}

  ngOnInit(): void {

    this.getRewardWallet();

    this.fetchRewardHistory();
    this.fetchAllCashback();

  }

showOverview() {
  this.activePage = 'overview';
}

showTransactions() {
  this.activePage = 'transactions';
}
showCashback() {
  this.activePage = 'cashback';
}

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || '';
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }


getRewardWallet(): void {
    // const userId = this.getCurrentUserId();
 const userId = this.getCurrentUserId();
  if (!userId) {
    console.warn('⚠️ User ID not found');
    return;
  }

  this.wallwtservice.getRewardWallet(userId).subscribe({
    next: (res: any) => {

      this.wallet = res.wallet; // ya res.data (API response ke according)

      console.log('Reward :', this.wallet);

      this.loading = false;
    },
    error: (err) => {

      console.error('Error fetching reward history:', err);

      this.loading = false;
    }
  });

}
fetchRewardHistory(): void {
 const userId = this.getCurrentUserId();
  if (!userId) {
    console.warn('⚠️ User ID not found');
    return;
  }
  
  this.wallwtservice.getRewardHistory(userId).subscribe({
    next: (res: any) => {
      
      this.rewardHistory = res.history;
      
      // Reset
      this.totalCredit = 0;
      this.totalDebit = 0;
      this.totalBalance = 0;
      
      // Calculate Total Credit & Debit
      this.rewardHistory.forEach((item: any) => {
        
        if (item.type === 'Credit') {
          this.totalCredit += item.reward;
        }
        
        if (item.type === 'Debit') {
          this.totalDebit += item.reward;
        }
        
      });
      this.totalBalance = this. totalCredit + this.totalDebit;
      this.loading = false;

    },
    error: (err) => {

      console.error(err);
      this.loading = false;

    }
  });

}

fetchAllCashback(): void {
  this.loading = true;

  this.wallwtservice.getAllCoupons().subscribe({
    next: (res: any) => {

      this.cashbackHistory = res.coupons || [];
      console.log(this.cashbackHistory);

      this.loading = false;
    },
    error: (err) => {
      console.error(err);
      this.loading = false;
    }
  });
}
selectedFilter = 'All';

fromDate: string = '';
toDate: string = '';
filterType(type: string = 'All') {

  this.selectedFilter = type;
  this.applyFilter();

}
applyFilter() {
this.rewardHistory = [];
  this.loading = true;

  this.wallwtservice.filterRewardHistory(
    this.selectedFilter,
    this.fromDate,
    this.toDate
  ).subscribe({

    next: (res: any) => {

      this.rewardHistory = res.history;
      console.log(this.rewardHistory);
      this.loading = false;

    },

    error: (err) => {

      console.log(err);
      this.loading = false;

    }

  });

}

clearFilter() {

  this.selectedFilter = 'All';
  this.fromDate = '';
  this.toDate = '';

  this.applyFilter();

}






  
// getWallet() {

//   this.http.get<any>(
//     `http://localhost:5000/api/getRewardWallet/${this.userId}`
//   ).subscribe(res => {

//     this.wallet = res.wallet;

//     this.balance = res.wallet.balance;

//     // Save balance in localStorage
//     localStorage.setItem('rewardBalance', this.balance.toString());

//   });

// }



  getHistory() {

    this.http.get<any>(
      `http://localhost:5000/api/getRewardHistory/${this.userId}`
    ).subscribe(res => {

      this.history = res.history;

    });

  }

  getTotalEarned() {
    if (!this.history || this.history.length === 0) return 0;
    return this.history.reduce((sum, item) => sum + (item.reward || 0), 0);
  }

  isCredit(item: any): boolean {
    // Check if type field exists and use it, otherwise fall back to reward value
    if (item.type) {
      return item.type.toLowerCase() === 'credit';
    }
    // Fallback: if reward is positive, it's a credit
    return item.reward >= 0;
  }

  

// wallet = {

//     balance: 677,

//     cashback: 240,

//     spent: 1723

//   };

//   history = [

//     {
//       description:'Cashback Reward',
//       amount:40,
//       type:'credit',
//       date:'18 Jul 2026'
//     },

//     {
//       description:'Order #VM9201',
//       amount:563,
//       type:'debit',
//       date:'18 Jul 2026'
//     },

//     {
//       description:'Cashback Reward',
//       amount:40,
//       type:'credit',
//       date:'15 Jul 2026'
//     }

//   ];

}
